import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Productlifecycle(props) {
  return (
    <div>
      <Container className="h-100 tekrevol_dark_bg p-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Cloud">
              <h2>
                Embrace Infrastructure Migration to Stabilize the Online
                Business Structure
              </h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <p>
              Infrastructure migration becomes an integral part of your online
              business structure and is flexible enough to resist the hiccups at
              any point. Our solutions are tailored to each client's needs and
              ensure that your digital infrastructure is aligned with future
              business requirements seamlessly. Whether updating old ones or
              boosting cloud use to improve the overall business security, we
              help you to make it better and stay successful.
            </p>
            <p>
              Access the possibilities of migration infrastructure to the point
              that you will be able to build and federalize your online
              business. Our wide range of services will make the complex periods
              an easier one, with you as the confident navigator using the
              latest technology and practices. Adopt modern infrastructure
              solutions that provide flexibility and scalability, thereby
              fortifying your business with a competitive edge in the world of
              digital sheer competition.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Cloud App
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Productlifecycle;
